import {useRouter} from 'next/router';
import {RouterHolder} from '@local/logics/global/routerHolder';

export const RouterConnector = () => {
  RouterHolder.router = useRouter();
  return null;
};
